// src/components/CompanyCard/CompanyCard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CompanyCard.css';

const CompanyCard = ({ company }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    // Navigate to company-specific dashboard
    navigate(`/company/${company.id}/dashboard`);
  };

  // Default logo if not provided
  const defaultLogo = (
    <svg 
      width="50" 
      height="50" 
      viewBox="0 0 60 60" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="60" height="60" rx="8" fill="#2D3748"/>
      <path 
        d="M30 15L38 22V42H22V22L30 15Z M26 26H34V38H26V26Z" 
        fill="#48BB78"
      />
    </svg>
  );

  return (
    <div className="company-card" onClick={handleCardClick} style={{ cursor: 'pointer' }}>
      <div className="company-card-content">
        <div className="company-logo">
          {company.logo ? (
            <img src={company.logo} alt={company.name} />
          ) : (
            defaultLogo
          )}
        </div>
        <div className="company-info">
          <p className="company-name">{company.name}</p>
          {company.code && (
            <span className="company-code">{company.code}</span>
          )}
        </div>
      </div>
      {company.description && (
        <div className="company-description">
          <p>{company.description}</p>
        </div>
      )}
      <div className="company-footer">
        {company.email && (
          <span className="company-email">{company.email}</span>
        )}
        {company.phone && (
          <span className="company-phone">{company.phone}</span>
        )}
      </div>
    </div>
  );
};

export default CompanyCard;